import type { ArrayElementType } from '@/core/types/gengeric';
import type { PlacingVariantsFilter, PlacingVariantType } from '@/parts/tariffs/types/tariffs';
import type { RouteLocation } from 'vue-router';
import { RouteNames } from '@/core/plugins/router/routeNames';

export const rangeTouristTypesString = (props: { from: number | null; to?: number | null } | null | undefined) => {
  if (!props || !('from' in props) || !('to' in props)) {
    return '';
  }

  return `${props.from}-${props.to}`;
};

export const touristTypeString = (
  props:
    | {
        touristType: { isAdult?: boolean; ageCategory?: { from: number; to?: number } | null };
      }
    | null
    | undefined,
) => {
  if (!props) {
    return 'Весь номер';
  } else if (props.touristType.isAdult) {
    return 'Взрослый';
  } else {
    return `Ребенок с ${props.touristType.ageCategory?.from} ${props.touristType.ageCategory?.to ? `до ${props.touristType.ageCategory?.to}` : ''}`;
  }
};

export const touristPlaceName = (isAdditional: boolean | undefined) => (isAdditional ? 'Доп.' : 'Осн.');

export const defaultPlacingVariantsFilter = (): PlacingVariantsFilter => ({
  roomCategory: null,
  touristType: null,
  onlyConflicted: false,
});

export const compareTouristTypes = (
  p: ArrayElementType<PlacingVariantType['suggestedPlacingVariants']>,
  touristType: string,
) =>
  p.placingVariant.baseSeats.find((s) => touristType === rangeTouristTypesString(s.touristType.ageCategory)) ||
  p.placingVariant.extSeats.find((s) => touristType === rangeTouristTypesString(s.touristType.ageCategory));

export const filterPlacingVariantsByTouristType = (
  placingVariants: PlacingVariantType['suggestedPlacingVariants'],
  touristType: string,
): PlacingVariantType['suggestedPlacingVariants'] => placingVariants.filter((p) => compareTouristTypes(p, touristType));

export const isTariffPage = (route: RouteLocation) => route.matched[0]?.name === RouteNames.Tariff;
